<template>
  <div class="party-relation">
    <div class="work-time">
      <p>工作年月</p>
      <el-date-picker v-model="workTime" align="right" type="date" placeholder="选择日期"></el-date-picker>
    </div>

    <div class="work-unit">
      <p>工作单位</p>
      <el-input placeholder="请输入内容" v-model="workUnit" clearable></el-input>
    </div>
    <div class="party-type">
      <p>党员类型</p>
      <el-select v-model="partyType" clearable placeholder="请选择">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </div>
    <div class="join-time">
      <p>入党日期</p>
      <el-date-picker v-model="joinTime" align="right" type="date" placeholder="选择日期"></el-date-picker>
    </div>
    <div class="connect-phone">
      <p>联系电话</p>
      <el-input placeholder="请输入内容" v-model="connectPhone" clearable></el-input>
    </div>
    <div class="roll-in-organ">
      <p>转入地组织</p>
      <el-input placeholder="请输入内容" v-model="rollInOrgan" clearable></el-input>
    </div>
    <div class="roll-out-time">
      <p>转往党组织</p>
      <el-input placeholder="请输入内容" v-model="rollOutOrgan" clearable></el-input>
    </div>
    <div class="party-money-time">
      <p>党费交到日期</p>
      <el-date-picker v-model="partyMoneyTime" align="right" type="date" placeholder="选择日期"></el-date-picker>
    </div>
    <div class="raw-party-fax">
      <p>原所在基层党委传真</p>
      <el-input placeholder="请输入内容" v-model="rawPartyFax" clearable></el-input>
    </div>
    <div class="raw-party-postcode">
      <p>原所在基层党委邮编</p>
      <el-input placeholder="请输入内容" v-model="rawPartyPostcode" clearable></el-input>
    </div>

    <div class="submit">
      <button>立即提交</button>
    </div>
  </div>
</template>



<script>
export default {
  data() {
    return {
      workTime: "",
      workUnit: "",
      options: [
        {
          value: "选项1",
          label: "暂无数据"
        },
 
      ],
      partyType: "",
      joinTime: "",
      officialTime: "",
      connectPhone: "",
      rollInOrgan: "",
      rollOutOrgan: "",
      partyMoneyTime: "",
      rawPartyFax: "",
      rawPartyPostcode: ""
    };
  },
  name: "partyRelation",
  props: {},

};
</script>

<style lang="scss" scoped>
.party-relation {
  .submit {
    button {
      padding: 0.2rem 0.4rem;
      background-image: linear-gradient(-70deg, #f9b94d 0%, #fdcb76 100%);
      box-shadow: 0px .06rem .12rem 0px rgba(249, 185, 77, 0.4);
      border-radius: .08rem;
      border: 0;
      color: #fff;
      font-size: .3rem;
    }
    padding: .3rem 0;
    text-align: center;
    
  }
  .join-time,
  .official-time,
  .connect-phone,
  .roll-in-organ,
  .roll-out-time,
  .party-money-time,
  .raw-party-postcode,
  .raw-party-fax,
  .party-type,
  .work-unit,
  .work-time {
    p {
      width: 30%;
    }

    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.2rem;
    border-bottom: 0.01rem solid #e6e6e6;
  }
}
</style>

<style lang="scss" >
.party-relation {
  .join-time,
  .roll-out-time,
  .official-time,
  .party-money-time,
  .work-time {
    .el-input {
      width: 40%;
    }
  }
  input {
    border: 0;
    text-align: right;
  }
}
</style>
